export default __webpack_public_path__ + "static/media/header_three.42ef0bba.jpg";